import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-651abaea"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("寵物資料")
const _hoisted_2 = {
  key: 0,
  class: "spin"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = { class: "bg-1" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "ion-text-center" }, "您想", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "ion-text-center" }, "寵物放入保鮮花裡嗎？", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = /*#__PURE__*/_createTextVNode("想")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("不想")
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = { class: "bg-2" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "ion-text-center" }, "您的寵物⋯", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "ion-text-center" }, "寵物 1", -1))
const _hoisted_16 = { class: "ion-text-center" }
const _hoisted_17 = ["src"]
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" 清除選擇 ")
const _hoisted_19 = { class: "ion-text-center ion-margin-vertical" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" 下一步 ")
const _hoisted_21 = { class: "bg-3" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "您的寵物是⋯", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_26 = { class: "bg-3" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "您的寵物品種⋯", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_30 = { class: "bg-3" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_32 = ["src"]
const _hoisted_33 = ["src"]
const _hoisted_34 = { class: "ion-text-center ion-margin-vertical" }
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" 下一步 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_card_subtitle = _resolveComponent("ion-card-subtitle")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_header, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_toolbar, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_buttons, { slot: "start" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_button, {
                  slot: "icon-only",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, { icon: _ctx.arrowBackOutline }, null, 8, ["icon"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ion_title, { class: "ion-text-start" }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ion_content, { class: "ion-text-center" }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_grid, { fixed: "" }, {
          default: _withCtx(() => [
            (_ctx.loadingData)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(_component_ion_spinner)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _withDirectives(_createElementVNode("div", null, [
                    _createVNode(_component_ion_icon, {
                      class: "icon-close",
                      icon: _ctx.close
                    }, null, 8, ["icon"]),
                    _hoisted_4,
                    _createElementVNode("div", _hoisted_5, [
                      _hoisted_6,
                      _hoisted_7,
                      _hoisted_8,
                      _createVNode(_component_ion_grid, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_col, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_button, {
                                class: "button-text",
                                shape: "round",
                                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setDesignWithPets(true)))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_9
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_col, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_button, {
                                class: "button-text",
                                shape: "round",
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setDesignWithPets(false)))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_10
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ])
                  ], 512), [
                    [_vShow, _ctx.currSection == _ctx.SECTIONS.withPets]
                  ]),
                  _withDirectives(_createElementVNode("div", null, [
                    _hoisted_11,
                    _createElementVNode("div", _hoisted_12, [
                      _hoisted_13,
                      _hoisted_14,
                      _hoisted_15,
                      _createElementVNode("div", _hoisted_16, [
                        (_ctx.design.pet1)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              style: {"width":"100px"},
                              src: _ctx.design.pet1.photoLink
                            }, null, 8, _hoisted_17))
                          : _createCommentVNode("", true)
                      ]),
                      _createVNode(_component_ion_button, {
                        class: "button-quantity",
                        shape: "round",
                        style: {"color":"gray"},
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setTargetPetNumber(1)))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.design.pet1 ? _ctx.design.pet1.petTypeName || '選擇品種' : '選擇品種') + " ", 1),
                          _createVNode(_component_ion_icon, {
                            slot: "end",
                            icon: _ctx.arrowForward
                          }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }),
                      _withDirectives(_createVNode(_component_ion_button, {
                        color: "danger",
                        fill: "clear",
                        size: "small",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.clearDesignPet(1)))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_18,
                          _createVNode(_component_ion_icon, {
                            slot: "end",
                            icon: _ctx.close
                          }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }, 512), [
                        [_vShow, _ctx.design.pet1]
                      ]),
                      _withDirectives(_createElementVNode("div", null, [
                        _createElementVNode("p", _hoisted_19, [
                          _createVNode(_component_ion_button, {
                            size: "middle",
                            shape: "round",
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.calculateNumOfPets()))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_20,
                              _createVNode(_component_ion_icon, {
                                slot: "end",
                                icon: _ctx.arrowForward
                              }, null, 8, ["icon"])
                            ]),
                            _: 1
                          })
                        ])
                      ], 512), [
                        [_vShow, _ctx.getCurrNumOfPets() > 0]
                      ])
                    ])
                  ], 512), [
                    [_vShow, _ctx.currSection == _ctx.SECTIONS.numOfPets]
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_21, [
                    _createVNode(_component_ion_icon, {
                      class: "icon-close",
                      icon: _ctx.close,
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.currSection = _ctx.SECTIONS.numOfPets))
                    }, null, 8, ["icon"]),
                    _hoisted_22,
                    _hoisted_23,
                    _hoisted_24,
                    _createVNode(_component_ion_grid, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_row, null, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.petCategories, (category) => {
                              return (_openBlock(), _createBlock(_component_ion_col, {
                                size: "6",
                                key: category
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_button, {
                                    class: "button-text",
                                    shape: "round",
                                    onClick: ($event: any) => (_ctx.setTargetPetCategory(category))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(category), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"])
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ], 512), [
                    [_vShow, _ctx.currSection == _ctx.SECTIONS.petCategories]
                  ]),
                  _withDirectives(_createElementVNode("div", null, [
                    _createVNode(_component_ion_icon, {
                      class: "icon-close",
                      icon: _ctx.close,
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.currSection = _ctx.SECTIONS.numOfPets))
                    }, null, 8, ["icon"]),
                    _hoisted_25,
                    _createElementVNode("div", _hoisted_26, [
                      _hoisted_27,
                      _hoisted_28,
                      _createElementVNode("div", null, [
                        _createVNode(_component_ion_grid, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_row, null, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.groupedPets[_ctx.targetPetCategory] || {}), (pets, breed) => {
                                  return (_openBlock(), _createBlock(_component_ion_col, {
                                    size: "6",
                                    key: breed
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_button, {
                                        class: "button-kind",
                                        size: "large",
                                        shape: "round",
                                        style: {"color":"black"},
                                        onClick: ($event: any) => (_ctx.onSelectPetBreed(breed, pets))
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(breed), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"])
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ], 512), [
                    [_vShow, _ctx.currSection == _ctx.SECTIONS.petBreeds]
                  ]),
                  _withDirectives(_createElementVNode("div", null, [
                    _createVNode(_component_ion_icon, {
                      class: "icon-close",
                      icon: _ctx.close,
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.currSection = _ctx.SECTIONS.petBreeds))
                    }, null, 8, ["icon"]),
                    _hoisted_29,
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("h1", null, "您的" + _toDisplayString(_ctx.targetPetBreed) + "顏色⋯", 1),
                      _hoisted_31,
                      _createVNode(_component_ion_grid, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_row, null, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.groupedPets[_ctx.targetPetCategory][_ctx.targetPetBreed] || []), (pet) => {
                                return (_openBlock(), _createBlock(_component_ion_col, {
                                  size: "6",
                                  key: pet.id
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_card, {
                                      onClick: ($event: any) => (_ctx.setDesignPet(pet)),
                                      button: ""
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_card_header, null, {
                                          default: _withCtx(() => [
                                            _createElementVNode("img", {
                                              style: {"max-height":"100px"},
                                              src: pet.photoLink
                                            }, null, 8, _hoisted_32),
                                            _createVNode(_component_ion_card_subtitle, null, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(pet.color), 1)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"])
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ])
                  ], 512), [
                    [_vShow, _ctx.currSection == _ctx.SECTIONS.petColors]
                  ]),
                  _withDirectives(_createElementVNode("div", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bottles, (bottle) => {
                      return (_openBlock(), _createBlock(_component_ion_card, {
                        class: "ion-text-center bottle-card",
                        key: bottle.id,
                        onClick: ($event: any) => (_ctx.setDesignBottle(bottle)),
                        button: ""
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("img", {
                            class: "img-size",
                            src: bottle.glassPhotoLink
                          }, null, 8, _hoisted_33),
                          _createVNode(_component_ion_card_title, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(bottle.name), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_ion_card_content, null, {
                            default: _withCtx(() => [
                              _createTextVNode("尺寸：" + _toDisplayString(bottle.size), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    }), 128)),
                    _createElementVNode("p", _hoisted_34, [
                      _createVNode(_component_ion_button, {
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.goToDesignDetailPage())),
                        size: "large",
                        shape: "round"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_35,
                          _createVNode(_component_ion_icon, {
                            slot: "end",
                            icon: _ctx.arrowForward
                          }, null, 8, ["icon"])
                        ]),
                        _: 1
                      })
                    ])
                  ], 512), [
                    [_vShow, _ctx.currSection == _ctx.SECTIONS.bottles]
                  ])
                ]))
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}